export default __webpack_public_path__ + "static/media/ArrowForMobileVersion.48e596ac.svg";